import {apiTemplate} from "@/core/helpers/api.js";

export class Processes {
  static async getCompanyInfo() {
    const userLocale = localStorage.getItem('gift-digital-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        parameters {
          companyAddress
          companyName
          companyPhoneNumber
          emailFrom
          emailHostUser
          projectName
          paymentGatewayMinimum
          paymentGatewayMaximum
        }
      }`
    );

    return await response;
  }

  static async topUpBalance(amount, accessToken) {
    const userLocale = localStorage.getItem('gift-digital-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "X-SCHON-AUTH": `Bearer ${accessToken}`,
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
          deposit(amount: ${amount}) {
            transaction {
              process
            }
          }
        }`
    );

    return await response;
  }

  static async contact(payload) {
    const userLocale = localStorage.getItem('gift-digital-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        contactUs (email: "${payload.email}", message: "${payload.message}", name: "${payload.name}", subject: "") {
          error
          received
        }
      }`
    );

    return await response;
  }

  static async getPaymentLimits() {
    const userLocale = localStorage.getItem('gift-digital-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        paymentsLimits {
          maxAmount
          minAmount
        }
      }`
    );

    return await response;
  }
}